/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { CommentRepresentation } from '../model/commentRepresentation';
import { ResultListDataRepresentationCommentRepresentation } from '../model/resultListDataRepresentationCommentRepresentation';
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
export class ActivitiCommentsApi extends BaseApi {
    addProcessInstanceComment(commentRequest, processInstanceId) {
        throwIfNotDefined(commentRequest, 'commentRequest');
        throwIfNotDefined(processInstanceId, 'processInstanceId');
        const pathParams = {
            processInstanceId
        };
        return this.post({
            path: '/api/enterprise/process-instances/{processInstanceId}/comments',
            pathParams,
            bodyParam: commentRequest,
            returnType: CommentRepresentation
        });
    }
    addTaskComment(commentRequest, taskId) {
        throwIfNotDefined(commentRequest, 'commentRequest');
        throwIfNotDefined(taskId, 'taskId');
        const pathParams = {
            taskId
        };
        return this.post({
            path: '/api/enterprise/tasks/{taskId}/comments',
            pathParams,
            bodyParam: commentRequest,
            returnType: CommentRepresentation
        });
    }
    getProcessInstanceComments(processInstanceId, opts) {
        throwIfNotDefined(processInstanceId, 'processInstanceId');
        const pathParams = {
            processInstanceId
        };
        return this.get({
            path: '/api/enterprise/process-instances/{processInstanceId}/comments',
            pathParams,
            queryParams: opts,
            returnType: ResultListDataRepresentationCommentRepresentation
        });
    }
    getTaskComments(taskId, opts) {
        throwIfNotDefined(taskId, 'taskId');
        const pathParams = {
            taskId
        };
        return this.get({
            path: '/api/enterprise/tasks/{taskId}/comments',
            pathParams,
            queryParams: opts,
            returnType: ResultListDataRepresentationCommentRepresentation
        });
    }
}
